import type { OptionallyResponsiveProp } from './responsiveProps'

export const getColSpan = (
    itemCount: number
): OptionallyResponsiveProp<number> => {
    switch (itemCount) {
        case 1:
            return { _: 12 }
        case 2:
            return { _: 12, sm: 6 }
        case 3:
            return { _: 12, sm: 6, md: 4 }
        default:
            return { _: 12, sm: 6, md: 3 }
    }
}

/**
 * returns a flat array of span objects for each item in a grid
 */
export const getColSpanByRow = (
    rowsAndColumns: number[],
    itemCount: number
): OptionallyResponsiveProp<number>[] => {
    const sumOfRowColumns = rowsAndColumns.reduce((a, b) => a + b, 0)

    if (sumOfRowColumns === 0) return []

    const colSpans: OptionallyResponsiveProp<number>[] = []

    rowsAndColumns.map((row) => {
        colSpans.push(...Array.from({ length: row }, () => getColSpan(row)))
    })

    // if there are more items than the sum of the row columns, use the most recent span for the rest
    if (itemCount > sumOfRowColumns) {
        const remainingItems = itemCount - sumOfRowColumns
        const lastItem = colSpans[colSpans.length - 1]
        colSpans.push(...Array.from({ length: remainingItems }, () => lastItem))
    }

    return colSpans
}
